import { customDesignUIReducer } from './customDesignUIReducer';
import { pageOpenDetectionReducer } from './pageOpenDetectionReducer';
import { partsViewUIReducer } from './partsViewUIReducer';
import { orderPartsHelpeUIReducer } from './orderPartsHelpReducer';
import { dialogReducer } from './dialogReducer';
import { editCartUIReducer } from './editCartUIReducer';

export * from './customDesignUIReducer';

export const uiReducers = {
    uiCustomDesign: customDesignUIReducer,
    pageOpenDetection: pageOpenDetectionReducer,
    uiPartsView: partsViewUIReducer,
    uiOrderPartsHelp: orderPartsHelpeUIReducer,
    uiDialog: dialogReducer,
    uiEditCart: editCartUIReducer,
};
